'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    (0, _jquery2.default)('.product-icon-group').each(function () {
        var $this = (0, _jquery2.default)(this);
        var count = $this.find('.product-icon').length;
        if (count > 3) {
            $this.addClass('product-icon-group--wrap');
        }
    });
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/tableLabelBreak.js
// module id = 950
// module chunks = 0